import gql from "graphql-tag";

export const GQL_CREDENTIALS_QUERY = gql`
  query Credentials(
    $search: String
    $credential_type: CredentialType
    $credential_types: [CredentialType]
    $limit: Int
    $offset: Int
  ) {
    response: credentials(
      search: $search
      credential_type: $credential_type
      credential_types: $credential_types
      limit: $limit
      offset: $offset
    ) {
      ... on CredentialsQuerySuccess {
        status
        data {
          id
          account
          credential_type
          display_name
          description
          hint
          username
          version
          used_secret_properties
          created_at
          service_variable_count
          created_by {
            id
            first_name
            last_name
          }
        }
        total
      }
      ... on CredentialError {
        status
        message
      }
    }
  }
`;

export const GQL_CREDENTIAL_QUERY = gql`
  query Credential($id: ID!) {
    response: credential(id: $id) {
      ... on CredentialQuerySuccess {
        status
        data {
          id
          account
          credential_type
          display_name
          description
          hint
          username
          version
          used_secret_properties
          created_by {
            id
          }
          services {
            id
            name
            device {
              id
              address
            }
          }
        }
      }
      ... on CredentialError {
        status
        message
      }
    }
  }
`;

export const GQL_CREDENTIAL_CREATE = gql`
  mutation CreateCredential(
    $credential_type: CredentialType!
    $display_name: String!
    $description: String
    $username: String
    $secret: CredentialSecret!
  ) {
    response: createCredential(
      data: {
        credential_type: $credential_type
        display_name: $display_name
        description: $description
        username: $username
        secret: $secret
      }
    ) {
      ... on CredentialMutationSuccess {
        status
        data {
          id
          account
          credential_type
          display_name
          description
          hint
          username
          version
          used_secret_properties
          created_by {
            id
          }
        }
      }
      ... on CredentialError {
        status
        message
      }
    }
  }
`;

export const GQL_CREDENTIAL_UPDATE = gql`
  mutation UpdateCredential(
    $id: ID!
    $display_name: String!
    $description: String
    $username: String
    $secret: CredentialSecret
  ) {
    response: updateCredential(
      id: $id
      data: {display_name: $display_name, description: $description, username: $username, secret: $secret}
    ) {
      ... on CredentialMutationSuccess {
        status
        data {
          id
          account
          credential_type
          display_name
          description
          hint
          username
          version
          used_secret_properties
          created_by {
            id
          }
        }
      }
      ... on CredentialError {
        status
        message
      }
    }
  }
`;

export const GQL_CREDENTIAL_DELETE = gql`
  mutation DeleteCredential($id: ID!) {
    response: deleteCredential(id: $id) {
      ... on CredentialMutationSuccess {
        status
        data {
          id
        }
      }
      ... on CredentialError {
        status
        message
      }
    }
  }
`;
